import React, {useEffect} from 'react'
import { useNavigate, useLocation } from 'react-router-dom';


import { BiExit } from "react-icons/bi";

// import KitchenIcon from '@mui/icons-material/Kitchen';

import { useAuthState } from '../contexts/authcontext'
import { useLoadRequests } from "../hooks/memberhooks";
// import { useLoadMemberships } from "../hooks/memberhooks";
import { useLoadAuthUser } from "../hooks/authhooks";

// import { ReactComponent as HomeIcon } from '../icons/Home.svg'
import { ReactComponent as CommunityIcon } from '../icons/CommunityIcon.svg'
import { ReactComponent as MembershipIcon } from '../icons/MembershipIcon.svg'
import { ReactComponent as ResourcesIcon } from '../icons/ResourcesIcon.svg'
import { ReactComponent as DashboardIcon } from '../icons/DashboardIcon.svg'
import { ReactComponent as CollapseIcon } from '../icons/CollapseIcon.svg'
import { ReactComponent as PaymentsIcon } from '../icons/PaymentsIcon.svg'
import { ReactComponent as SettingsIcon } from '../icons/Settings.svg'
import { ReactComponent as MessageIcon } from '../icons/MessageIconSelected.svg'
// import { ReactComponent as LoginIcon } from '../icons/Login.svg'
// import { ReactComponent as InventoryIcon } from '../icons/InventoryIcon.svg'
import homecook_logo from '../assets/img/homecook_logo.png'
import { isResourcePath } from '../utils/helpers';
import { isLeadsAdminEmail } from '../utils/leadsAdmin';
import { useTeamAccess } from '../hooks/communityhook';
import { canAccessAny, sidebarItemPermissionFlags } from '../utils/teamPermissions';
import GroupsIcon from '@mui/icons-material/Groups';
import { useAppState } from '../contexts/appcontext';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { SvgIconProps } from '@mui/material/SvgIcon';



// import homecook_logo from '../assets/img/homecook_logo.png'
// import DarkModeSwitcher from '../components/switcher'
// const account_avatar: string = `https://upload.wikimedia.org/wikipedia/commons/1/1e/Default-avatar.jpg`



type SideBarOptions = {
    name: string,
    path: string,
    icon: React.FC<React.SVGProps<SVGSVGElement>> | React.ComponentType<SvgIconProps>
    image?: string
}


var unauthDrawerItems: SideBarOptions[] = [
    {
        name: 'Logout',
        path: '',
        icon: BiExit
    }
]

var authDrawerItems: SideBarOptions[] = [
    {
        name: 'Collapse',
        path: '',
        icon: CollapseIcon
    },
    {
        name: 'Dashboard',
        path: '/',
        icon: DashboardIcon
    },
    {
        name: 'Community',
        path: '/community',
        icon: CommunityIcon
    },
    {
        name: 'Memberships',
        path: '/memberships/agreement',
        icon: MembershipIcon
    },
    {
        name: 'Resources',
        path: '/resources',
        icon: ResourcesIcon
    },
    {
        name: 'Messages',
        path: '/messages',
        icon: MessageIcon
    },
    // {
    //     name: 'Inventory',
    //     path: '/inventory',
    //     icon: InventoryIcon
    // },
    // {
    //     name: 'Reservations',
    //     path: '/kitchens/reservations',
    //     icon: BookingsIcon
    // },
    {
        name: 'Payments',
        path: '/payments',
        icon: PaymentsIcon
    },
    // {
    //     name: 'Self Service',
    //     path: '/self-service',
    //     icon: HowToRegIcon
    // },
    {
        name: 'Leads CRM',
        path: '/leads',
        icon: GroupsIcon
    },
    {
        name: 'Settings',
        path: '/settings',
        icon: SettingsIcon
    },
    // {
    //     name: 'Account',
    //     path: '/account',
    //     icon: AiOutlineUser,
    //     image: account_avatar
    // },

    // {
    //     name: 'Logout',
    //     path: '',
    //     icon: BiExit
    // }
]



const SideBar = () => {
    const navigate = useNavigate();

    var { isloggedin, isverified, authUser } = useAuthState()
    var { membershipRequests } = useLoadRequests()
    var { signOutUser } = useLoadAuthUser()
    const {isCollapsed, toggleIsCollapsed} = useAppState()
    const { permissions, isTeamLoading } = useTeamAccess()
    //  console.log("membershipRequests", membershipRequests)

    var view_postonboard = isloggedin && isverified
    var nMembershipRequests: number = membershipRequests ? membershipRequests.length : 0
    //  var view_otp_form = isloggedin && !isverified

    useEffect(()=> {}, [nMembershipRequests, view_postonboard])

    const clickNav = (route: string, itemName: string) => {
        if (itemName === "Collapse" && toggleIsCollapsed !== undefined){
            toggleIsCollapsed()
        } else {
            navigate(route)
            if (itemName === "Logout") {
                // Handle logout logic here
                // For example, reset the logged-in state to false
                signOutUser()
            }
        }
    }

    const location = useLocation()
    var currentLocation = location.pathname
    var drawerItems = view_postonboard ? authDrawerItems : unauthDrawerItems
    if (!isLeadsAdminEmail(authUser?.email ?? authUser?.username)) {
        drawerItems = drawerItems.filter((item) => item.name !== 'Leads CRM')
    }
    if (!isTeamLoading) {
        drawerItems = drawerItems.filter((item) => {
            const flags = sidebarItemPermissionFlags(item.name)
            return !flags || canAccessAny(permissions, flags)
        })
    }


    const getPathName = (input: string): string => {
        return input.replace("/", "").replace(/^\w/, (c) => c.toUpperCase());
      }
    
    var currentPageName = getPathName(currentLocation)
    const resourceType = isResourcePath(currentPageName)

    return (
    <div className={`${isCollapsed ? 'w-[90px]' : 'w-[250px]'} top-0 left-0 bottom-0 mt-0 mb-0 ml-0 sm:h-screen fixed bg-white border-r border-[#E9E9E9] duration-300 overflow-x-hidden ${isloggedin ? 'visible' : 'invisible'} `}>
        {/* <img src={homecook_logo} className='relative w-20' alt='/' /> */}
        <div className='flex flex-row mx-auto my-2'>
            <img src={homecook_logo} alt="HomeCook Kitchen Logo" className="relative w-20 my-auto" />
            {
                (isCollapsed) ? (<></>) : (<h1 className='text-ink font-raleway font-bold text-xl my-auto'>HomeCook</h1>)
            }
        </div>
        

        <nav>
            <ul className='flex flex-col flex-start text-ink my-6'>
                { 
                    drawerItems.map((item, i) => {
                    return (
                            <li 
                                key={i} 
                                className={`
                                    flex flex-row w-full h-[50px] 
                                    cursor-pointer font-raleway text-[16px] my-auto 
                                    ${
                                        (currentLocation === item.path || (
                                            item.path && currentLocation.includes(`/${resourceType}`) && currentLocation.includes(`${item.path}/`)
                                               && isResourcePath(currentLocation)
                                            ) || (
                                                item.name === "Self Service" && currentLocation.includes("/self-service")
                                            ) || (
                                                item.name === "Memberships" && currentLocation.includes("memberships")
                                            ) || (
                                                item.name === "Leads CRM" && currentLocation.startsWith("/leads")
                                            )
                                        ) ? 
                                            `bg-primary-tint w-full mx-auto rounded-lg text-primary-100 font-semibold ${(["/"].includes(item.path)) ? 'fill-[#013847]' : ''}` 
                                        : 'text-muted hover:bg-primary-tint/60 hover:text-primary-100'
                                    } 
                                    `} 
                                onClick={() => clickNav(item.path, item.name)}
                            >
                                <item.icon className={`relative my-auto w-[24px] h-[24px] ml-7`} />
                                {
                                    (isCollapsed) ? (<></>) : (<p className={`my-auto mx-4`}>{item.name}</p>)
                                }
                            </li>
                        )
                    })
                }
        
                {/* <DarkModeSwitcher /> */}

            </ul> 
        </nav>
    </div>
  )
}

export default SideBar


